function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.837 1.047a.335.335 0 00-.33-.007c-.024.013-2.443 1.293-7.507 1.293S.517 1.053.493 1.04A.332.332 0 000 1.333v12c0 .056.016.11.041.158.008.014.022.024.032.037.02.027.036.054.063.074.005.004.01.002.015.005.005.004.007.01.012.012.052.03.11.046.168.047h.002a.337.337 0 00.1-.015l2.725-.86c1.198-.25 2.801-.458 4.842-.458 5.064 0 7.483 1.28 7.507 1.293a.33.33 0 00.33-.006.334.334 0 00.163-.287v-12a.332.332 0 00-.163-.286zM8.052 3.41c3.69 0 5.895-.694 6.786-1.052v7.84l-2.54-3.015a.32.32 0 00-.473 0l-1.26 1.496-1.938-3.286A.31.31 0 008.1 5.38L5.546 9.312l-1.89-2.136a.31.31 0 00-.5.05L1.266 10.5V2.357c.891.358 3.097 1.052 6.786 1.052zM3.333 6.333a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z",
  fill: "currentColor"
});

function SvgPanoramicView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPanoramicView;